<template>
  <v-list dense class="membros-list">
    <v-list-item
      v-for="(membro, index) in membros"
      :key="index"
      class="mb-6 link-item"
      :style="`animation-delay: ${index * 150}ms`"
    >
      <template v-for="(valor, chave) in membro" :key="chave">
        <div
          v-if="valor"
          :class="{
            'campo-1': chave === '1',
            'campo-2': chave === '2',
            'campo-3': chave === '3',
            'campo-mais': !['1','2','3'].includes(String(chave))
          }"
          v-html="formatarTexto(valor)"
        />
      </template>
    </v-list-item>
  </v-list>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'

interface Membro {
  [key: string]: string
}

defineProps<{ membros: Membro[] }>()

function formatarTexto(texto: string): string {
  if (!texto) return ''
  return texto
    .replace(/\r\n|\r/g, '\n')
    .replace(/\n{2,}/g, '\n')
    .replace(/[ \t]+/g, ' ')
    .trim()
    .replace(/\n/g, '<br>')
}
</script>

<style scoped>
.membros-list {
  display: grid;
  gap: 14px;
  background: transparent;
}

.campo-1 {
  font-weight: 700;
  text-transform: uppercase;
  color: var(--funarpen-blue);
  font-size: 1.15rem;
  margin-bottom: 0.2rem;
  user-select: text;
}
.campo-2 {
  font-weight: 600;
  color: var(--funarpen-ink);
  font-size: 1.1rem;
  margin-bottom: 0.2rem;
  user-select: text;
}
.campo-3 {
  color: rgba(16, 35, 52, 0.78);
  font-size: 1rem;
  line-height: 1.5;
  user-select: text;
}
.campo-mais {
  color: var(--funarpen-muted);
  font-size: 0.95rem;
  margin-top: 0.1rem;
  user-select: text;
}

.link-item {
  padding: 1rem 1.15rem;
  border: 1px solid rgba(8, 47, 73, 0.1);
  border-left: 5px solid var(--funarpen-gold);
  border-radius: var(--funarpen-radius);
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 253, 0.92)),
    #fff;
  box-shadow: 0 10px 24px rgba(8, 47, 73, 0.06);
  width: 100% !important;
  cursor: pointer;
  opacity: 0;
  animation: fadeInUp 0.5s forwards ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .campo-1 {
    font-size: 1rem !important;
  }
  .campo-2 {
    font-size: 0.95rem !important;
  }
  .campo-3 {
    font-size: 0.9rem !important;
  }
  .campo-mais {
    font-size: 0.85rem !important;
  }
}
</style>
